import AppDispatcher from '../dispatcher/AuthenticationAppDispatcher'
import FluxAuthenticationConstants from '../constants/FluxAuthenticationConstants'

const FluxAuthenticationActions = {

    // Log a user
    logged: function(user) {
        AppDispatcher.handleAction({
            actionType: FluxAuthenticationConstants.LOGGED,
            user: user
        })
    },

    unauthorized: function() {
        AppDispatcher.handleAction({
            actionType: FluxAuthenticationConstants.UNAUTHORIZED
        })
    }
};

export default FluxAuthenticationActions;
